export const BUSINESS_GLOSSARY_TYPE = 'BusinessGlossary';
export const GOVERNANCE_TAG_TYPE = 'DataGovernanceSubjectArea';
export const GLOBAL_GLOSSARY_TYPE = 'Glossary#Global';
export const USER_GLOSSARY_TYPE = 'Glossary#User';
export const USER_TYPE = 'User';
export const GLOBAL_TYPE = 'Global';

export const glossaryTypeDisplayName: Map<string, string> = new Map([
  [GOVERNANCE_TAG_TYPE, 'Governance tag'],
  [BUSINESS_GLOSSARY_TYPE, 'Business glossary'],
]);

export const glossaryTypeDisplayNameLowerCase: Map<string, string> = new Map([
  [GOVERNANCE_TAG_TYPE, 'governance tag'],
  [BUSINESS_GLOSSARY_TYPE, 'business glossary'],
]);
